import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { Carousel, CarouselSlide } from '@redturtle/volto-rt-carousel';
import ViewSlide from '@redturtle/volto-io-studio/components/Blocks/Reviews/Slide/ViewSlide';
import carouselConfig from '@redturtle/volto-io-studio/components/Blocks/Reviews/carouselConfig';

import './view.less';

const View = ({ data, block }) => {
  const intl = useIntl();
  const SlideComponent = ViewSlide;

  return (
    <div className="block reviewsBlock">
      {data.items?.length > 0 && (
        <Carousel
          items={data.items}
          loop={false}
          slideComponent={({ item, index }) => (
            <SlideComponent item={data.items[index]} index={index} />
          )}
          {...carouselConfig}
          key={'carousel' + block}
        />
      )}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

View.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
